import { leaveLinkedCancellationCaption } from "../../../../utils/leaveRequestDesk";

export function linkedCancellationTrailSteps(linked) {
  const steps = Array.isArray(linked?.workflowTrail) ? linked.workflowTrail : [];
  const decided = steps.some((s) => {
    const st = String(s?.status || "").toLowerCase();
    return st === "approved" || st === "rejected";
  });
  const mapped = steps
    .filter((step) => {
      const status = String(step?.status || "").trim().toLowerCase();
      if (decided && (status === "pending" || status === "current")) return false;
      return true;
    })
    .map((step) => ({
      ...step,
      note: step?.note || step?.reason || "Leave cancellation",
      _source: "cancellation",
    }));
  if (mapped.length) return mapped;
  if (!linked?.status) return [];
  return [
    {
      status: linked.status,
      actor: linked.actorName || "Approver",
      actedAt: linked.updatedAt || linked.submittedAt,
      note: "Leave cancellation",
      _source: "cancellation",
    },
  ];
}

/** Nested cancellation facts under the original Leave card (trail renders on the side). */
export default function LeaveLinkedCancellationBlock({ linkedCancellation }) {
  if (!linkedCancellation) return null;
  const status = String(linkedCancellation.status || "Pending");
  const caption = leaveLinkedCancellationCaption(linkedCancellation);
  const reason = String(linkedCancellation.reason || "").trim();
  const notes = String(linkedCancellation.notes || "").trim();
  const approved = status.toLowerCase() === "approved";

  return (
    <div className="rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))]/30 p-3">
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="text-base font-semibold text-[hsl(var(--ds-fg))]">
          Leave cancellation
        </span>
        <span className="text-xs text-[hsl(var(--ds-muted-fg))]">· {status}</span>
      </div>
      {caption ? (
        <p
          className={`mt-1 text-sm ${
            approved
              ? "font-medium text-[hsl(var(--ds-danger))]"
              : "text-[hsl(var(--ds-fg))]"
          }`}
        >
          {caption}
        </p>
      ) : null}
      {reason ? (
        <p className="mt-2 text-xs leading-relaxed text-[hsl(var(--ds-muted-fg))]">
          {reason}
        </p>
      ) : null}
      {notes ? (
        <p className="mt-1 text-[11px] text-[hsl(var(--ds-muted-fg))]">Note: {notes}</p>
      ) : null}
    </div>
  );
}
